import ClientSuspense from '@components/ClientSuspense'
import logger from '@helpers/logger'
import useEffect from '@hooks/useEffect'
import useWebsiteCoinsBalanceNavBar from '@page-components/Order/Products/ProductsContent/WebsiteCoins/useWebsiteCoinsBalanceNavBar.main'
import useOrderDetails from '@page-components/TrackV2/sections/Order/useOrderDetails.main'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'
import useLazyAnalyticsV2 from '../hooks/useLazyAnalyticsV2'

function TrackPurchaseInner() {
  const order = useOrderDetails()
  const mutate = useMutate()
  const analyticsV2 = useLazyAnalyticsV2()
  const {me} = useWebsiteCoinsBalanceNavBar(order?.websiteId)

  const informTrack = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation TrackingV2InformOrderTrack($orderId: ID) {
            informOrderTrack(orderId: $orderId) {
              _id
              didTrack
            }
          }
        `,
        variables: {orderId: order._id},
        refetchQueries: ['TrackingV2GetOrder'],
      })
    } catch (error) {
      logger.warn(error)
    }
  }

  useEffect(() => {
    if (order.didTrack || order.paymentStatus !== 'done') return

    const extraProperties = me?.websiteCoinsBalance
      ? {websiteCoinsBalance: me.websiteCoinsBalance}
      : {}

    analyticsV2.trackPurchaseOnAll(order, extraProperties)
    informTrack()
  }, [order.didTrack, order.paymentStatus, me?.websiteCoinsBalance])

  return null
}

export default function TrackPurchase() {
  return (
    <ClientSuspense fallback={null}>
      <TrackPurchaseInner />
    </ClientSuspense>
  )
}
